import apiClient from '../apiClient';

export const signalFailingImageUrl = async (imageUrl: string) => {
    try {
        const response = await apiClient(`/products/signal-failing-image-url`, {
            method: 'POST',
            // headers: {
            //     Authorization: `Bearer ${authToken}`,
            // },
            body: JSON.stringify({
                imageUrl: imageUrl,
            }),
        });
    } catch (error: any) {
        console.error('Failed to signal failing image URL:', error.message);

        if (error.statusCode === 401) {
            console.warn('Unauthorized: Removing invalid token');
        }
    }
};
